import { render, staticRenderFns } from "./contact-form-fiscal-info-cmp.vue?vue&type=template&id=f5f2d246&scoped=true"
import script from "./contact-form-fiscal-info-cmp.vue?vue&type=script&lang=js"
export * from "./contact-form-fiscal-info-cmp.vue?vue&type=script&lang=js"
import style0 from "./contact-form-fiscal-info-cmp.vue?vue&type=style&index=0&id=f5f2d246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f2d246",
  null
  
)

export default component.exports